import React from "react";


function ZoomOut({ onTransform, disabled }  ) {

  /**
   * Handles the zoom out functionality when the user clicks the zoom out button.
   *
   * @param {React.MouseEvent} event - The click event object.
   * @returns {void}
   */
  const zoomObject = (event) => {
    if (!disabled) {
      onTransform( event, "zoom", -0.1 );
    }
  };

  return (
    <div
      className="toolbar-button"
      data-test={"image-zoom-out"}
      onClick={ zoomObject }
      style={disabled ? { opacity: 0.5, cursor: "not-allowed" } : {}}>
      <i className="fas fa-search-minus"></i>
    </div>
  );
}

export default ZoomOut;